import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AckFxModule } from "ack-angular-fx";
import { TranslatePipe } from '../../Pipes/translate.pipe';
import { HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LayoutModule } from '@angular/cdk/layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MenuPipe } from '../../Pipes/menu.pipe';
import { FormatDataPipe } from '../../Pipes/format-data.pipe';
import { FilterDataPipe } from '../../Pipes/filter-data.pipe';
import { MobileNumberDirective } from 'src/app/Modules/medical/directive/mobile-number.directive';
import { AllowNumberDirective } from 'src/app/Modules/medical/directive/allow-number.directive';
import { AllowStringNumericDirective } from 'src/app/Modules/medical/directive/allow-string-numeric.directive';
import { DateFormatDirective } from 'src/app/Modules/medical/directive/date-format.directive';
@NgModule({
  declarations: [     
    TranslatePipe,
    MenuPipe,
    FormatDataPipe,
    FilterDataPipe,
    MobileNumberDirective,
    AllowNumberDirective,
    AllowStringNumericDirective,
  ],

  exports:[
    TranslatePipe,
    FormatDataPipe,
    MenuPipe,  
    FilterDataPipe,
    FormsModule,   
    AckFxModule,
    ReactiveFormsModule,
    MobileNumberDirective
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    AckFxModule,
    CommonModule,
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ]
})
export class ShareModule { }
